import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { CohortService } from '../service/cohort.service';
@Component({
	selector: 'app-info',
	templateUrl: './info.page.html',
	styleUrls: ['./info.page.scss'],
})
export class InfoPage implements OnInit {
	class = 'students';
	cohortName: any;
	routerURL$ = this.router.events.pipe(
		filter(val => val instanceof NavigationEnd),
		tap((val: any) => {
			if (val.url.indexOf('/students') > -1) {
				this.class = 'students';
			} else if (val.url.indexOf('/groups') > -1) {
				this.class = 'groups';
			} else if (val.url.indexOf('/properties') > -1) {
				this.class = 'properties';
			}
		}),
	);

	courseId: any;
	cohortId: any;

	constructor(
		public router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private cohortService: CohortService,
	) {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.class = locationPath[7];
		this.courseId = locationPath[3];
		this.cohortId = locationPath[6];
	}

	ngOnInit() {
		// // this.router.events.subscribe(val => console.log(val));
		// this.activatedRoute.params.subscribe(data => console.log(data, 'data...'));
		this.cohortService.loadCourseData(this.courseId).subscribe();
		this.cohortService.fetchCourseData(this.courseId).subscribe((data: any) => {
			if (data.data) {
				console.log(this.cohortId);
				this.cohortName = data.data.find(
					(data: any) => data.id == this.cohortId,
				);
				// console.log(this.cohortId, this.cohortName.id);
			}
		});
	}
	viewupdate(str: any) {
		this.activatedRoute.params.subscribe((data: any) => {
			this.router.navigate([
				`app/courses/${this.courseId}/cohorts/info/${this.cohortId}/${str}`,
			]);
		});
	}
}
